import { create } from "zustand";
import { payments as seed } from "@/mocks/seed";
import type { Payment } from "@/types";

/** Mock store standing in for the API when unauthenticated / API down (Phase 5.2).
 *  "Archive" is a soft remove — kept out of the active list but not destroyed. */
interface PaymentsState {
  active: Payment[];
  archived: Payment[];
  add: (payment: Payment) => void;
  update: (id: string, patch: Partial<Payment>) => void;
  archive: (id: string) => void;
  restore: (id: string) => void;
}

export const usePaymentsStore = create<PaymentsState>((set) => ({
  active: seed,
  archived: [],
  add: (payment) => set((s) => ({ active: [payment, ...s.active] })),
  update: (id, patch) =>
    set((s) => ({ active: s.active.map((p) => (p.id === id ? { ...p, ...patch } : p)) })),
  archive: (id) =>
    set((s) => {
      const target = s.active.find((p) => p.id === id);
      if (!target) return s;
      return { active: s.active.filter((p) => p.id !== id), archived: [target, ...s.archived] };
    }),
  restore: (id) =>
    set((s) => {
      const target = s.archived.find((p) => p.id === id);
      if (!target) return s;
      return { archived: s.archived.filter((p) => p.id !== id), active: [target, ...s.active] };
    }),
}));
